// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateCurrency_cancelButton__216QD"};